import { base_url } from "../../../../config";
import { profileImgSrc } from "../../../../config";

import industryImg from "../../../../assets/industry-icon.svg";
import employeeImg from "../../../../assets/employee-count-icon.svg";
import totalImg from "../../../../assets/total-funding-icon.svg";
import revenueImg from "../../../../assets/revenue-icon.svg";
import lastFundingImg from "../../../../assets/last-funding-round-icon.svg";

import linkedinIcon from "../../../../assets/linkedin-icon.svg";
import telegramIcon from "../../../../assets/telegram-icon.svg";
import xIcon from "../../../../assets/x-icon.svg";
import facebookIcon from "../../../../assets/facebook-icon.svg";
import youtubeIcon from "../../../../assets/youtube-icon.svg";

export default function CompanyProfileCard({ details }) {
  // console.log("job types", details.company_profile);
  return (
    <div className="company-profile-card-wrapper">
      <div className="company-profile__img">
        <img
          src={
            details?.company_profile?.avatar instanceof File
              ? URL.createObjectURL(details.company_profile.avatar)
              : details?.company_profile?.avatar
              ? `${base_url}${details.company_profile.avatar}`
              : `${profileImgSrc}`
          }
          alt="profile-img"
        />
      </div>
      <div className="company-profile__info">
        <h3>
          {details?.company_profile.company_name
            ? details?.company_profile.company_name
            : "No company name"}
        </h3>
        <div className="company-website">
          <p>
            {details?.company_profile.website
              ? details?.company_profile.website
              : "No data"}
          </p>
        </div>
        <div className="separator"></div>
        <div className="company-bio">
          <p>
            {!details?.company_profile?.bio
              ? "No data"
              : details?.company_profile?.bio}
          </p>
        </div>
        <div className="separator"></div>
        <div className="company-profile-info-details">
          <div className="company-info-single">
            <div className="company-info-single__img">
              <img src={employeeImg} alt="employee-icon" />
            </div>
            <div className="company-info-single__text">
              <span>Employee Count</span>
              <p>
                {!details?.company_profile.employee_count
                  ? "No data"
                  : details?.company_profile.employee_count}
              </p>
            </div>
          </div>
          <div className="company-info-single">
            <div className="company-info-single__img">
              <img src={totalImg} alt="total-funding-icon" />
            </div>
            <div className="company-info-single__text">
              <span>Total Funding</span>
              <p>
                {!details?.company_profile.total_funding
                  ? "No data"
                  : details?.company_profile.total_funding}
              </p>
            </div>
          </div>
          <div className="company-info-single">
            <div className="company-info-single__img">
              <img src={revenueImg} alt="total-funding-icon" />
            </div>
            <div className="company-info-single__text">
              <span>Revenue</span>
              <p>
                {!details?.company_profile.revenue
                  ? "No data"
                  : details?.company_profile.revenue}
              </p>
            </div>
          </div>
          <div className="company-info-single">
            <div className="company-info-single__img">
              <img src={lastFundingImg} alt="last-funding-icon" />
            </div>
            <div className="company-info-single__text">
              <span>Last Funding Round</span>
              <p>
                {details?.company_profile.last_funding_round
                  ? details?.company_profile.last_funding_round
                  : "No data"}
              </p>
            </div>
          </div>
          {/* <div className="company-info-single company-info-single-industry">
            <div className="company-info-single__img">
              <img src={industryImg} alt="industry-icon" />
            </div>
            <div className="company-info-single__text">
              <span>Industry</span>
              {details?.company_profile.job_types.map((curr) => (
                <p key={curr.id}>{curr.name}</p>
              ))}
            </div>
          </div> */}
        </div>
        <div className="separator"></div>
        <div className="company-profile-customers">
          <span>Customers</span>
          <p>
            {details?.company_profile.customers
              ? details?.company_profile.customers
              : "No data"}
          </p>
        </div>
        <div className="separator"></div>
        <div className="company-profile-location">
          <span>HQ Location</span>
          <div className="company-profile-location__wrapper">
            {details.locations ? (
              details.locations?.map((curr) => (
                <div className="company-location-single" key={curr.id}>
                  <p>
                    {curr.country},{curr.city}
                  </p>
                  <p>{curr.address}</p>
                </div>
              ))
            ) : (
              <p>No locations</p>
            )}
          </div>
        </div>
        <div className="separator"></div>
        <div className="company-profile-socials">
          <span>Social Media</span>
          <div className="profile-social-media__wrapper">
            {details?.company_profile.linkedin && (
              <a href={details.company_profile.linkedin}>
                <img src={linkedinIcon} alt="linkedin" />
              </a>
            )}
            {details?.company_profile.telegram && (
              <a href={details?.company_profile.telegram}>
                <img src={telegramIcon} alt="telegram" />
              </a>
            )}
            {details?.company_profile.twitter && (
              <a href={details?.company_profile.twitter}>
                <img src={xIcon} alt="x" />
              </a>
            )}
            {details?.company_profile.facebook && (
              <a href={details?.company_profile.facebook}>
                <img src={facebookIcon} alt="facebook" />
              </a>
            )}
            {details?.company_profile.youtube && (
              <a href={details?.company_profile.youtube}>
                <img src={youtubeIcon} alt="youtube" />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
